import React, { useState, useEffect } from 'react';
import {connect, useDispatch} from 'react-redux';
import { bindActionCreators}  from 'redux';
import S from 'StyledEventListTreeLayout.js';
import { loadLiveMajorGames } from 'liveEventActions.js';
import { CategoryTreeHeaderTab, CategoryTreeSportTab, CategoryTreeCategoryTab, CategoryTreeLiveEventTab } from 'EventListTreeLayout';


const EventListTreeLive = (props) => {
    
    let {liveEventSportId, liveEventSportName, liveEventId, liveCategoryId, liveMajorGames} = props;

    const [categoryLevel, setCategoryLevel] = useState(1);
    const [openLiveEventSportId, setOpenLiveEventSportId] = useState(liveEventSportId);
    const [openLiveEventSportName, setOpenLiveEventSportName] = useState(liveEventSportName);
    const [openLiveEventId] = useState(liveEventId);
    const [openCategoryIdTabs, setOpenCategoryIdTabs] = useState([liveCategoryId]);
    const [intervalId, setIntervalId] = useState();

    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(loadLiveMajorGames());

        let interval = setInterval(() => {
            dispatch(loadLiveMajorGames());
        }, 10000);

        setIntervalId(interval);

        return () => clearInterval(intervalId);

    }, []);

    const getSportTabs = () => {

        const selectSport = (sportId, sportName) => {
            setOpenLiveEventSportId(sportId);
            setOpenLiveEventSportName(sportName);
            setCategoryLevel(1);
        };

        let sportObjects = [];
        if (liveMajorGames.length > 0){
            for (let event of liveMajorGames) {
                let { sportId, sportName, sportSortOrder } = event;
                let sportAdded = sportObjects.find((o) => o.categoryId == sportId);
                if (sportAdded) {
                    sportAdded['categoryCount'] = sportAdded['categoryCount'] + 1;
                } else {
                    let sport = { categoryId: sportId, categoryName: sportName, sportSortOrder: sportSortOrder, categoryCount: 1 };
                    sportObjects.push(sport);
                }
            }
            sportObjects = _.sortBy(sportObjects, 'sportSortOrder');
        }
        let sportTabsJSX = [];

        for (let sport of sportObjects){
            let { categoryId, categoryName, categoryCount } = sport;
            sportTabsJSX.push(
                <CategoryTreeSportTab selectSport={selectSport} 
                    key={categoryId} 
                    categoryId={categoryId} 
                    categoryName={categoryName}
                    categoryCount={categoryCount}
                    showIcon={true}>    
                </CategoryTreeSportTab>
            );
        }

        return sportTabsJSX;
    };

    const getEventsList = (events) => {
        let eventsTabsJSX = [];
        for (let event of events) {
            eventsTabsJSX.push(
                <CategoryTreeLiveEventTab key={event.eventId}
                    event={event}
                    openLiveEventId={openLiveEventId}>
                </CategoryTreeLiveEventTab>
            );
        }
        
        return eventsTabsJSX;
    };

    const getCategoryTabs = () => {
        
        let categoryObjects = [];
		if ( liveMajorGames.length> 0 ){
        	let eventsInSport = liveMajorGames.filter(o => o.sportId == openLiveEventSportId);
       
            for (let eventInSport of eventsInSport) {
                let { categoryId, categoryName, categorySortOrder, parentId, parentSortOrder } = eventInSport;
                let categoryAdded = categoryObjects.find((o) => o.categoryId == categoryId);
                if (categoryAdded) {
                    categoryAdded['categoryCount'] = categoryAdded['categoryCount'] + 1;
                    categoryAdded['events'].push(eventInSport);
                } else {
                    let category = { categoryId, categoryName, categorySortOrder, parentId, parentSortOrder, categoryCount: 1, events: [eventInSport] };
                    categoryObjects.push(category);
                }
            }

            categoryObjects = _.chain(categoryObjects).sortBy('categorySortOrder').sortBy('parentSortOrder').value();
        }
        let categoryTabsJSX = [];

        for (let category of categoryObjects){

            let { categoryId, parentId, categoryName, categoryCount, events } = category;
           
            categoryTabsJSX.push(
                <CategoryTreeCategoryTab key={categoryId} 
                    toggleCategoryTab={toggleCategoryTab}
                    openCategoryIdTabs={openCategoryIdTabs}
                    categoryId={categoryId} 
                    categoryName={categoryName} 
                    categoryCount={categoryCount}
                    parentId={parentId}
                    events={events} 
                    getEventsList={getEventsList}>    
                </CategoryTreeCategoryTab>
            );
        }
        
        return categoryTabsJSX;
    };

    const toggleCategoryTab = (categoryId) => {
        if (openCategoryIdTabs.indexOf(categoryId) > -1){
            setOpenCategoryIdTabs(openCategoryIdTabs.filter(i => i !== categoryId));
        } else {
            setOpenCategoryIdTabs([...openCategoryIdTabs, categoryId]);
        }
    };

    const closeModalAcion = () => {
        clearInterval(intervalId);
        app.modal.EventList.hideEventListModal();
    };

    return (
        <S.LiveEventListTreeContainer>

            <CategoryTreeHeaderTab setCategoryLevel={setCategoryLevel}
                categoryLevel={categoryLevel} 
                categoryLevelForBackBtn={0}
                sportName={openLiveEventSportName}
                sportId={openLiveEventSportId} 
                closeModalAcion={closeModalAcion}>    
            </CategoryTreeHeaderTab>

            <S.RowTabContainer>
                { categoryLevel == 0 && getSportTabs() }
                { categoryLevel == 1 && getCategoryTabs() }
            </S.RowTabContainer>
     
        </S.LiveEventListTreeContainer>
    );
};

const mapDispatchToProps = (dispatch) => {
    const actionsToBind = { loadLiveMajorGames };
    return {
        ...bindActionCreators(actionsToBind, dispatch)
    }
};

const mapStateToProps = ({ LiveEvent: { liveMajorGames } }) => {
    return {
        liveMajorGames
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventListTreeLive);